import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "hooks/useAuth";
import Page401 from "pages/auth/Page401";
// ----------------------------------------------------------------------
export default function RequireRole({ roles, children }) {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  const userHasRequiredRole = () => {
    try {
      const hasRole =
        roles && user && roles.includes(user.role.code) ? true : false;
      return hasRole;
    } catch (error) {
      return false;
    }
  };

  if (isAuthenticated && !userHasRequiredRole()) {
    return <Page401 />;
  }

  return children;
}
